import type { DemandeProformaDTO } from '@/features/api/extranet/dto/Demande/PROFORMA'
import type { FichierDTO } from '@/features/api/extranet/dto/Demande/shared'
import type { ContextReglesProforma, ReglesProforma } from '@/features/domaine/regles-akto/PROFORMA/types.ts'
import {
  isAdherentOuMandatGestion,
  rgEstMaxLengthFactory,
  rgEstObligatoireFactory,
  rgEstVraiFactory,
} from '@/features/domaine/regles-akto/shared'
import { SAISIE_OBLIGATOIRE } from '@/features/domaine/regles-akto/shared/messages-erreurs.ts'
import { LevelRegleEnum } from '@/features/domaine/types/opco'
import { isNotNullUndefinedOrEmptyString } from '@/features/shared/tools'
import { addPreBuilder, type Flag, type ModelValidateurResult, type Regles } from '../../moteur-regles'
import { PropertyStatus } from '../../property-status'

// /* Initalisation des helpers */
const addPre = addPreBuilder<DemandeProformaDTO, ContextReglesProforma>()

/* Declaration de type pour les sous modeles */
type RegleProformaMembre<T extends object> = Regles<T, ContextReglesProforma, LevelRegleEnum, Flag, DemandeProformaDTO>

const reglesFichiers: RegleProformaMembre<FichierDTO> = {}

export const reglesConfiguration: ReglesProforma = {
  referenceExterne: {
    ...addPre((_value, _parent, _model, context) => context.status.lieuSignature?.$status === PropertyStatus.Required, {
      ...rgEstObligatoireFactory(LevelRegleEnum.Transmettre),
    }),
    ...rgEstMaxLengthFactory(30),
  },
  attestationSurHonneur: {
    ...rgEstVraiFactory(LevelRegleEnum.Transmettre),
  },
  acceptationCg: {
    ...rgEstVraiFactory(LevelRegleEnum.Transmettre),
  },
  lieuSignature: {
    ...addPre((_value, _parent, _model, context) => context.status.lieuSignature?.$status === PropertyStatus.Required, {
      ...rgEstObligatoireFactory(LevelRegleEnum.Transmettre),
    }),
  },
  fichiers: reglesFichiers,
  $model: {
    'rib-obligatoire': {
      validateur: (model) => ({
        rib: isNotNullUndefinedOrEmptyString(model?.rib?.iban),
      }),
      message: SAISIE_OBLIGATOIRE,
      level: LevelRegleEnum.Transmettre,
    },
    'dr-obligatoire': {
      validateur: (model) => ({
        remboursements: (model.remboursements?.length ?? 0) > 0,
      }),
      message: 'La proforma doit référencer au moins une demande de remboursement',
      level: LevelRegleEnum.Transmettre,
    },
    controleFichier: {
      validateur: (model, _globalModel, context) => {
        const result: ModelValidateurResult<DemandeProformaDTO> = {}

        if (isAdherentOuMandatGestion(context.typeContext, false)) {
          for (const doc of context.naturesFichiers.obligatoires) {
            if (model.fichiers?.filter((x) => x.nature === doc).length === 0) {
              result[`fichiers`] = false
            }
          }
        }
        return result
      },
      message: SAISIE_OBLIGATOIRE,
      level: LevelRegleEnum.Transmettre,
    },
  },
}
